import { render, staticRenderFns } from "./ViewLiveSocial.vue?vue&type=template&id=4100909c&scoped=true&"
import script from "./ViewLiveSocial.vue?vue&type=script&lang=ts&"
export * from "./ViewLiveSocial.vue?vue&type=script&lang=ts&"
import style0 from "./ViewLiveSocial.vue?vue&type=style&index=0&id=4100909c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4100909c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
